// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3Dqpd","label":"SetPasswdForm_label__3J-uI"};